import React from "react"
import { Box, ButtonBase, Typography } from "@mui/material"

import { dsColorNew } from "@palette"


// Two-or-more option selector from the Dataseekers retail front. Each option is a real button,
// so it keeps the keyboard access (Tab + Enter/Space) of the switch it replaces.
export default function AppPillToggle({ value, options = [], onChange, size = 'medium', ...props }) {
	const small = size === 'small'

	return <Box role="group" {...props} sx={{
		display: 'inline-flex',
		gap: '4px',
		p: small ? '3px' : '4px',
		borderRadius: small ? '10px' : '12px',
		backgroundColor: dsColorNew.pillTrackBg,
		border: `1px solid ${dsColorNew.grayBorder}`,
		...props?.sx,
	}}>
		{options.map(option => {
			const isActive = option.value === value
			// an option that does not apply stays, disabled with its reason (`patterns.md` § 5; CU-869fmjzrh)
			const disabled = !!option.disabled && !isActive

			return <ButtonBase
				key={option.value}
				aria-pressed={isActive}
				disabled={disabled}
				title={option.title || undefined}
				onClick={() => !isActive && !disabled && onChange(option.value)}
				sx={{
					...(disabled && { opacity: 0.45, cursor: 'not-allowed', pointerEvents: 'auto' }),
					px: small ? '14px' : '16px',
					py: small ? '6px' : '8px',
					borderRadius: small ? '8px' : '10px',
					transition: 'all 0.15s ease',
					border: '1.5px solid transparent',
					'&.Mui-focusVisible': { outline: `2px solid ${dsColorNew.webBlue500}`, outlineOffset: 1 },
					...(isActive && {
						backgroundColor: dsColorNew.pillActiveBg,
						borderColor: dsColorNew.appBlue,
					}),
				}}
			>
				<Typography sx={{
					fontSize: 13,
					fontWeight: isActive ? 600 : 500,
					color: isActive ? dsColorNew.appBlue : dsColorNew.textMuted,
					lineHeight: 1,
					whiteSpace: 'nowrap',
				}}>
					{option.label}
				</Typography>
			</ButtonBase>
		})}
	</Box>
}
